import React from "react";
import { Box } from "@mui/material";
import { Navigate } from "react-router-dom";
import SubTitle from "../common/SubTitle";
import NavMenu from "../navbar/NavMenu";
import AppSettings from "./AppSettings";
import HomeHeader from "../header/homeHeader/HomeHeader";
import TitleBar from "../../components/navbar/TitleBar";
import Footer from "../common/Footer";

export default function AppSettingsContainer() {
  // Get organizationId from localStorage
  let organizationId = null;
  try {
    const userStateString = localStorage.getItem("userState");
    if (userStateString) {
      const userState = JSON.parse(userStateString);
      organizationId = userState.user.organizationId;
    }
  } catch (error) {
    console.error("Error retrieving organizationId from localStorage:", error);
  }

  // Redirect to login if no organizationId
  if (!organizationId) {
    return <Navigate to="/login" replace />;
  }
  const orgName = JSON.parse(localStorage.getItem('userState'))?.organization?.name;
  return (
    <>
      <Box >
        <TitleBar />
        <NavMenu />
        <SubTitle
          title="Settings"
          path={`${orgName || "organization"}> Settings`} />
        <AppSettings />
      </Box>
      <Footer />
    </>
  );
}